export default __webpack_public_path__ + "static/media/ic_gmx_24.1df7d348.svg";